import { createComponent } from '@carvana/merch-components';

export const Wrapper = createComponent('div', {
  className:
    'flex items-center justify-between bg-background-default px-2xl py-lg md:px-0'
});
